import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { secondaryMarketDlpOrderTabContentPersisted } from 'state/secondaryMarket/dlpOrder/form/dlpOrderForm.actions';
import type { EpicWithThunk } from 'state/state.common';

export function persistDlpOrderTabContentEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { updateTabContent } = tabsApiConnector(httpClient, 'secondaryMarketQuotes');

    return actions$.pipe(
      ofType('SECONDARY_MARKET_DLP_ORDER_TAB_CONTENT_PERSIST_REQUESTED'),
      mergeMap(action => {
        return updateTabContent(action.tabId, {
          ...action.tabContent,
          workspace: 'secondaryMarketQuotes',
          tabType: 'dlpOrder',
        }).pipe(map(() => secondaryMarketDlpOrderTabContentPersisted(action.tabId, action.tabContent)));
      }),
    );
  };
}
